/*
 * @Author: jiangxd
 * @Date: 2021-08-17 11:28:25
 * @LastEditTime: 2022-09-21 13:26:32
 * @LastEditors: jiangxd
 * @Description:
 * @FilePath: /rs_ips_maintence/src/views/components/selectSite/RsuiSiteSelect.tsx
 */

import { client } from 'rsui-core/lib/post-message';
import { JsonToUrlParam } from '@/util';
import { EmpServiceAPIActions } from '@/services/empService';

export default class RsuiSiteSelect {
  public tokenData: ItemObject = {
    Authorization: `Bearer ${EmpServiceAPIActions.getTokenFromCache().token}`,
  };

  openSiteSelectPick(queryId, siteId, exArr, selectArr) {
    // domain
    const protocol = `${location.protocol}//`;
    let hostName = location.hostname;
    hostName.includes('host') && (hostName = 'ips.maintenance.qingger.cn');

    const conds = [
      {
        key: 'status',
        vals: [1],
      }, // 网点状态
    ];

    const params: any = {
      ext_ips__auth_token: this.tokenData.Authorization,
      ext_ips__site: siteId,
    };

    const str = JsonToUrlParam(params);
    return client.pick({
      domain: `${protocol + hostName}/scrm/web`,
      path: 'site-select-advn',
      modelDialog: true,
      slide: 'right',
      search: `?baseURL=/nips/scrm&${str}`,
      props: {
        hasPerms: false,
        zIndex: 99999999999,
        config: {
          hasPerms: false,
          subject: 'STORE',
          queryId: queryId || null,
          actId: null,
          pure: true,
          conditions: [],
          sicodes: selectArr || [],
          extProps: {
            excludeCode: exArr || [],
          },
          selectBy: ['ranges'],
          rangesConditions: conds,
          filterFields: ['id', 'name', 'type', 'address', 'status'],
        },
      },
      dialogStyle: {
        width: '50vw',
        height: '100vh',
        backgroudColor: '#eee',
      },
    });
  }
}
